import { createContext } from 'react'
import type { AuthStatus, GoogleUser } from '../lib/auth/auth-session.ts'

export interface AuthContextValue {
  user: GoogleUser | null
  status: AuthStatus
  /** status === 'active': Drive is reachable with the current token. */
  isAuthenticated: boolean
  /** This device has been signed in before, so it holds that account's local data. */
  hasAccount: boolean
  /** Kept for older call sites: the session restores synchronously now. */
  isLoading: boolean
  /** Set while status is 'account_mismatch'. */
  pendingUser: GoogleUser | null
  login: () => void
  reconnect: () => void
  grantPermissions: (extraScopes?: string[]) => void
  logout: () => void
}

export const AuthContext = createContext<AuthContextValue | null>(null)
